import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row mb-10" }
const _hoisted_4 = { class: "col-6 d-flex justify-content-start" }
const _hoisted_5 = {
  key: 0,
  class: "form-check me-3"
}
const _hoisted_6 = { class: "col-6 d-flex justify-content-end" }
const _hoisted_7 = { class: "form-group radio-group-right" }
const _hoisted_8 = { class: "d-flex align-items-center gap-15" }
const _hoisted_9 = {
  key: 0,
  class: "form-check me-3"
}
const _hoisted_10 = { class: "form-check me-3" }
const _hoisted_11 = {
  key: 1,
  class: "form-check me-3"
}
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-9" }
const _hoisted_14 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_17 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_18 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_19 = {
  key: 0,
  class: "col-md-2 mb-3"
}
const _hoisted_20 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_21 = {
  key: 1,
  class: "col-md-2"
}
const _hoisted_22 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = { class: "form-group mb-8 mb-sm-10 mb-md-15" }
const _hoisted_25 = { class: "col-md-3" }
const _hoisted_26 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_27 = { class: "col-md-12 mt-3" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = {
  key: 0,
  class: "btn btn-success me-3",
  type: "submit"
}
const _hoisted_30 = {
  class: "btn btn-success",
  type: "button",
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "factureForm",
        onSubmit: _ctx.addFacture,
        "validation-schema": _ctx.factureSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (!true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_Field, {
                      name: "showAib",
                      type: "checkbox",
                      id: "11",
                      value: true,
                      "unchecked-value": false,
                      class: "form-check-input",
                      modelValue: _ctx.showAib,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showAib) = $event))
                    }, null, 8, ["modelValue"]),
                    _cache[10] || (_cache[10] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "11"
                    }, " Appliquer l'AIB ", -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.nbElementsofContrat > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_Field, {
                          name: "natureFacture",
                          type: "radio",
                          value: 3,
                          id: "3",
                          class: "form-check-input",
                          modelValue: _ctx.natureFacture,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.natureFacture) = $event))
                        }, null, 8, ["modelValue"]),
                        _cache[11] || (_cache[11] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "3"
                        }, " Loyer & Electricité ", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_Field, {
                      name: "natureFacture",
                      type: "radio",
                      value: 0,
                      id: "0",
                      class: "form-check-input",
                      modelValue: _ctx.natureFacture,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.natureFacture) = $event)),
                      checked: _ctx.natureFacture == 0
                    }, null, 8, ["modelValue", "checked"]),
                    _cache[12] || (_cache[12] = _createElementVNode("label", {
                      class: "form-check-label",
                      for: "0"
                    }, " Loyer ", -1))
                  ]),
                  (_ctx.nbElementsofContrat > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createVNode(_component_Field, {
                          name: "natureFacture",
                          type: "radio",
                          value: 2,
                          id: "2",
                          class: "form-check-input",
                          modelValue: _ctx.natureFacture,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.natureFacture) = $event)),
                          checked: _ctx.natureFacture == 2
                        }, null, 8, ["modelValue", "checked"]),
                        _cache[13] || (_cache[13] = _createElementVNode("label", {
                          class: "form-check-label",
                          for: "2"
                        }, " Electricité ", -1))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_ErrorMessage, {
                  name: "natureFacture",
                  class: "text-danger"
                })
              ])
            ])
          ]),
          _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Contrat "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "contrat" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      contratholder: "Rechercher une contrat",
                      "filter-results": false,
                      onSelect: _ctx.contratSelect,
                      "min-chars": 3,
                      "resolve-on-load": false,
                      delay: 0,
                      searchable: true,
                      "options-limit": 300,
                      options: async (query) => {
                    return await _ctx.fetchContrats(query)
                  },
                      noResultText: "Aucun enregistrement trouvé",
                      noOptionsText: "Tapez au moins trois caractères"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "onSelect", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "contrat",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Date facture "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "date_facture",
                  type: "date",
                  value: _ctx.date_facture,
                  class: "form-control shadow-none fs-md-15 text-black",
                  contratholder: "Entrer la date de facture"
                }, null, 8, ["value"]),
                _createVNode(_component_ErrorMessage, {
                  name: "date_facture",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass( _ctx.showAib ? 'col-md-2 mb-3' : 'col-md-3 mb-3')
            }, [
              _createElementVNode("div", _hoisted_17, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                  _createTextVNode(" Mois "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "mois",
                  modelValue: _ctx.mois,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mois) = $event)),
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      searchable: true,
                      options: [
                  { value: 0, label: 'Janvier' },
                  { value: 1, label: 'Février' },
                  { value: 2, label: 'Mars' },
                  { value: 3, label: 'Avril' },
                  { value: 4, label: 'Mai' },
                  { value: 5, label: 'Juin' },
                  { value: 6, label: 'Juillet' },
                  { value: 7, label: 'Août' },
                  { value: 8, label: 'Septembre' },
                  { value: 9, label: 'Octobre' },
                  { value: 10, label: 'Novembre' },
                  { value: 11, label: 'Décembre' },
                ],
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { contratholder: "Sélectionner le mois" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "mois",
                  class: "text-danger"
                })
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass( _ctx.showAib ? 'col-md-2 mb-3' : 'col-md-3 mb-3')
            }, [
              _createElementVNode("div", _hoisted_18, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                  _createTextVNode(" Année "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "annee" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      options: _ctx.years,
                      searchable: true,
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, { contratholder: "Sélectionner une année" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "annee",
                  class: "text-danger"
                })
              ])
            ], 2),
            (_ctx.showAib)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "d-block text-black mb-10" }, [
                      _createTextVNode(" AIB "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "aib",
                      modelValue: _ctx.aib,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.aib) = $event)),
                      type: "text"
                    }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          searchable: true,
                          disabled: true,
                          options: [
                  { value: 1, label: '1 %' },
                  { value: 5, label: '5 %' },
                ],
                          modelValue: field.value,
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                        }, field, { contratholder: "Sélectionner un élément" }), null, 16, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "aib",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.showAib)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                      _createTextVNode(" Montant Aib "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "montant_aib",
                      modelValue: _ctx.montant_aib,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.montant_aib) = $event)),
                      type: "number",
                      disabled: true,
                      class: "form-control shadow-none fs-md-15 text-black",
                      contratholder: "Entrer le montant"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "montant_aib",
                      class: "text-danger"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Montant facture "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "montant_facture",
                  modelValue: _ctx.montant_facture,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.montant_facture) = $event)),
                  type: "number",
                  disabled: true,
                  class: "form-control shadow-none fs-md-15 text-black",
                  contratholder: "Entrer le montant"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "montant_facture",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Date limite de paiement "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "dateLimit",
                  type: "date",
                  modelValue: _ctx.dateLimit,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dateLimit) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "dateLimit",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                (_ctx.checkPermission('AddContrat'))
                  ? _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_29, " Enregistrer ", 512)), [
                      [_vShow, !_ctx.auclic]
                    ])
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("button", {
                  class: "btn btn-success me-3",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.normalise && _ctx.normalise(...args))),
                  type: "submit"
                }, " Enregistrer & Normaliser ", 512), [
                  [_vShow, !_ctx.auclic]
                ]),
                _withDirectives(_createElementVNode("button", _hoisted_30, _cache[22] || (_cache[22] = [
                  _createElementVNode("span", {
                    class: "spinner-grow spinner-grow-sm",
                    role: "status",
                    "aria-hidden": "true"
                  }, null, -1),
                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
                ]), 512), [
                  [_vShow, _ctx.auclic]
                ]),
                _createVNode(_component_router_link, {
                  to: "/liste-facture",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}